import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  title: {
    display: 'flex',
    alignItems: 'center',

    '& > *': {
      cursor: 'pointer'
    },

    '& > :first-child': {
      marginRight: '16px'
    }
  }
}))

export default useStyles
